import React from 'react';

import PHIAuditCollectionFindings from './PHIAuditCollectionFindings';
import PHIAuditPageFindings from './PHIAuditPageFindings';

const PHIAuditFindings = ({
  hasFindings,
  hasCollectionFindings,
  hasPageFindings,
  flaggedCollections,
  flaggedPages,
}) => {
  if (!hasFindings) {
    return (
      <div className="text-center border rounded p-4">
        <div
          className="d-flex align-items-center justify-content-center rounded-circle mx-auto mb-3"
          style={{
            width: '52px',
            height: '52px',
            backgroundColor: '#e8f7ed',
          }}
        >
          <i
            className="fa fa-check"
            style={{
              fontSize: '22px',
              color: '#28a745',
            }}
          />
        </div>

        <h6 className="fw-semibold mb-2">No potential PHI exposure found</h6>

        <p className="text-muted small mb-0">
          No likely PHI exposure was identified in this project's collections, fields, public
          filters, or public pages.
        </p>
      </div>
    );
  }

  return (
    <>
      {hasCollectionFindings && (
        <PHIAuditCollectionFindings flaggedCollections={flaggedCollections} />
      )}

      {hasPageFindings && <PHIAuditPageFindings flaggedPages={flaggedPages} />}
    </>
  );
};

export default PHIAuditFindings;
